import type { ParamDef, ParamSection } from '../types/scene'

export function getParamSection(param: ParamDef): ParamSection {
  if (param.section) return param.section
  if (param.type === 'number') return 'geometry'
  if (param.type === 'color') return 'appearance'
  return 'behavior'
}

export function isParamVisible(param: ParamDef, params: Record<string, any> | undefined): boolean {
  if (!param.visibleWhen) return true
  return param.visibleWhen(params ?? {})
}
